import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { LayoutDashboard, Tags, Layers, Megaphone, Home, Inbox, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/layout/Navbar";

const LINKS = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/brands", label: "Brands & ranges", icon: Tags },
  { to: "/admin/categories", label: "Categories", icon: Layers },
  { to: "/admin/promotions", label: "Promotions", icon: Megaphone },
  { to: "/admin/homepage", label: "Homepage", icon: Home },
  { to: "/admin/enquiries", label: "Enquiries", icon: Inbox },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-[var(--muted)]">Loading…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-[#f4f1ea] flex" data-testid="admin-layout">
      <aside className="w-64 shrink-0 bg-[var(--ink)] text-[var(--cream)] flex flex-col sticky top-0 h-screen">
        <div className="p-6 border-b border-white/10"><Logo light /><p className="eyebrow !text-[0.6rem] text-[var(--stone)] mt-2">Content manager</p></div>
        <nav className="p-3 flex-1 space-y-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase().split(" ")[0]}`} className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${isActive ? "bg-[var(--terracotta)] text-[var(--cream)]" : "text-[var(--stone)] hover:bg-white/5 hover:text-[var(--cream)]"}`}>
              <l.icon size={16} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-2 text-xs text-[var(--stone)] hover:text-[var(--cream)]" data-testid="admin-view-site"><ExternalLink size={12} /> View live site</Link>
          <p className="text-xs text-[var(--stone)] truncate">{user.email}</p>
          <button onClick={logout} data-testid="admin-logout" className="flex items-center gap-2 text-xs text-[var(--stone)] hover:text-[var(--cream)]"><LogOut size={12} /> Sign out</button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-8 lg:p-12"><Outlet /></main>
    </div>
  );
}
